import { type AppointmentStage } from "@repo/api";
import {
  calendarIcon,
  documentFinancialIcon,
  documentMagnifyingIcon,
  headphonesIcon,
  storeIcon,
} from "@repo/skapa";
import { CustomColors, makeAlphaColor } from "@repo/ui";

const CALENDAR_DEFAULT_ALPHA_VALUE = "0.2";

export const AppointmentConfiguration: Record<
  AppointmentStage,
  { icon: any; remoteIcon: any; color: string; borderColor: string }
> = {
  OPEN: {
    icon: calendarIcon,
    remoteIcon: headphonesIcon,
    color: makeAlphaColor(
      CustomColors.planningAppointment,
      CALENDAR_DEFAULT_ALPHA_VALUE
    ),
    borderColor: CustomColors.planningAppointment,
  },
  PLANNING: {
    icon: storeIcon,
    remoteIcon: headphonesIcon,
    color: makeAlphaColor(
      CustomColors.planningAppointment,
      CALENDAR_DEFAULT_ALPHA_VALUE
    ),
    borderColor: CustomColors.planningAppointment,
  },
  VERIFICATION: {
    icon: documentMagnifyingIcon,
    remoteIcon: headphonesIcon,
    color: makeAlphaColor(
      CustomColors.verificationAppointment,
      CALENDAR_DEFAULT_ALPHA_VALUE
    ),
    borderColor: CustomColors.verificationAppointment,
  },
  ORDER: {
    icon: documentFinancialIcon,
    remoteIcon: headphonesIcon,
    color: makeAlphaColor(
      CustomColors.orderAppointment,
      CALENDAR_DEFAULT_ALPHA_VALUE
    ),
    borderColor: CustomColors.orderAppointment,
  },
};
